import {Injectable} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Injectable({
    providedIn: 'root'
})
export class TaskEditService {

    constructor() {
    }

    public getTaskDurationError(taskForm: FormGroup): string {
        if (taskForm.controls['duration'].errors) {
            if (taskForm.controls['duration'].errors.required) {
                return 'TASK_DURATION_REQUIRED';
            }
            if (taskForm.controls['duration'].errors.min) {
                return 'TASK_DURATION_ZERO';
            }
            if (taskForm.controls['duration'].errors.durationTooLong) {
                return 'TASK_DURATION_TOO_LONG';
            }
        }
        return null;
    }
}
